import React, { useEffect } from "react";
import { ProblemDetails } from "@domain/schemas/BI";
import { AuthService } from "@infrastructure/services";
import { useInjection } from "../dependencyInjection";
import { useUserManagementStore } from "@presentation/stores";
import { useNotifications, FullscreenLoader } from "@presentation/components/notifications";
import { signInProgress, logOutInProgress } from "@presentation/components/helpers/constants";

const OidcCallback: React.FC = () => {
  const { pushNotification } = useNotifications();
  const authService = useInjection(AuthService);

  useEffect(() => {
    const exchangeToken = async () => {
      try {
        const currentState = useUserManagementStore.getState();
        if (currentState.userSession.accessToken) {
          return;
        }
        const wasLoggedOut = sessionStorage.getItem(logOutInProgress) === "true";
        if (wasLoggedOut) {
          return; // Skip if we were logged out
        }
        await authService.signIn();
        sessionStorage.removeItem(signInProgress);
        console.info("OIDC login successful");
        window.location.href = "/";
      } catch (error: unknown) {
        let message = "OIDC login failed";
        if (error instanceof Response) {
          try {
            const problem: ProblemDetails = await error.json();
            message = problem.detail || problem.title || message;
          } catch {
            /* empty */
          }
        }
        pushNotification(message, "error", 5000);
        console.error("OIDC login error:", error);
      }
    };

    exchangeToken();
  }, [authService, pushNotification]);

  return <FullscreenLoader />;
};

export default OidcCallback;
